export default __webpack_public_path__ + "static/media/Hubano-4.accceec7.png";